export default {
  dynamics: '{{change}} vs. semana anterior',
};
